//表格公用组件
import React, {Component} from 'react';
import './style/MyTable.css'
import {Tabs, TreeSelect, Input, Table, Divider, Tag, Pagination,Select} from 'antd';
import PropTypes from 'prop-types';
import {Scrollbars} from "react-custom-scrollbars";
import BaseTable from "../../components/baseTable/BaseTable";
import $Jq from "jquery";
const {TabPane} = Tabs;
const { Option, OptGroup } = Select;
//下拉栏
// const IconFont=Icon.createFromIconfontCN({
//     scriptUrl:'//at.alicdn.com/t/font_3298136_f4aejzh6lru.js',
// });

const {Search} = Input;

class MyTable extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        $Jq('.ant-pagination-options-quick-jumper').find("input").val("");
    }

    onChange = value => {
        this.setState({ value });
    };

    callback=(key) =>{
    };

    render() {
        return (
            <div style={{backgroundColor: "#fff",margin: 15, borderRadius: 5, overflow: "hidden"}}>
                {/*导航栏*/}
                {this.renderManuscriptNav()}
                {/*表格*/}
                {this.renderTable()}
                {/*分页栏*/}
                {this.renderPage()}
            </div>

        );
    }
    handleChange = () =>{

    };
    //导航栏,下拉栏,搜索框
    renderManuscriptNav = () => {
        let {placeholder,searchPlaceholder,tabChange,navigationBarDate,reviewData,onChange,treeData}=this.props;
        // console.log(treeData)
        return (
            <div>
                <div className={'materialCenterSearch'} style={{display:'flex'}}>
                    <style>
                        {
                            `
                            .materialCenterSearch .ant-input,.materialCenterSearch .ant-select-selection {
                                background-color: #f5f8fc;
                            }
                            `
                        }
                    </style>
                    {/*下拉框*/}
                    <div style={{paddingLeft: 30}}>
                        <Select defaultValue="全部稿件"
                                style={{width: '224px', paddingTop: '24px'}}
                                placeholder={placeholder}
                                onSelect={(value, record) => {
                                    let key;
                                     if(value === '全部稿件'){
                                         key = ''
                                     }else{
                                         key = record.key
                                     }
                                    onChange('onSelect', key)
                                }}
                        >

                            <Option value="全部稿件">全部媒体</Option>
                            {
                                treeData.length && treeData.map((item, index) => {
                                    return (
                                        <OptGroup key={item.id || index} label={<div><img width={16} src={item.logoUrl} style={{margin:"0 5px",borderRadius:"50%"}}/> {item.mediaTypeName}</div>}>
                                            {item.mediaList && item.mediaList.length && item.mediaList.map(sonItem => {
                                                return (
                                                    <Option key={sonItem.id}
                                                            value={sonItem.id}>{sonItem.name}</Option>
                                                )
                                            })}
                                        </OptGroup>
                                    )
                                })
                            }
                        </Select>
                    </div>
                    {/*搜索框*/}
                    <div style={{paddingTop:'25px'}}>
                        <Search
                            allowClear
                            placeholder={searchPlaceholder}
                            onChange={(e)=>{onChange('onChange',e)}}
                            onSearch={(e)=>{onChange('onSearch',e)}}
                            style={{width: 272,height:32,paddingLeft:'24px'}}
                        />
                    </div>
                </div>
                {/*导航栏*/}
                <div className={'navigationBarStyle'}>
                    {
                        (navigationBarDate && navigationBarDate.length)
                            ?
                            (<Tabs defaultActiveKey="1" onChange={tabChange}>
                                {
                                    navigationBarDate.map((item, index) => {
                                        return (
                                            <TabPane tab={item.key} key={item.key}/>
                                        )
                                    })
                                }

                            </Tabs>)
                            : null
                    }
                    {
                       ( reviewData && reviewData>=99 && navigationBarDate.key=='待我审核')?( <div style={{borderRadius:'50%',backgroundColor:'red',color:'white',
                            position:'absolute',left:'238px',top:'0px',width:'16px',height:'16px',
                            fontSize:'9px',textAlign:'center'
                        }}>{reviewData}</div>):null
                    }

                </div>
            </div>
        )
    }
    //表格
    renderTable = () => {
        let {columns,dataSource,tableHeight}=this.props;
        return (
            <div style={{margin:"20px 30px 0"}} className="interval">
                <Scrollbars autoHeight autoHeightMax={tableHeight}>
                    <BaseTable columns={columns} dataSource={dataSource}/>
                </Scrollbars>
            </div>
        )
    };
   // 分页栏
    renderPage=()=>{
        let {onChange,total,params,dataSource}=this.props;
        if(!total) return <div style={{height:81}}></div>;
        if(!(dataSource&&dataSource.length>0) && params.page>1) {
            onChange('page',--params.page);
        }
        return(
            <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                borderTop: '1px solid #eee',
                padding: '24px 32px',}}
            >
                <Pagination
                    size="middle"
                    total={total}
                    showTotal={(total) => `共有${total}条数据`}
                    showSizeChanger
                    showQuickJumper
                    current={params.page}
                    pageSize={params.size}
                    onChange={(page,pageSize)=>{onChange('page',page)}} //页码改变时回调
                    onShowSizeChange={(page,pageSize)=>{onChange('size',pageSize)}} //每页条数改变回调
                />
            </div>
        )
    }
}

MyTable.propTypes={
    /**
     * @text 搜索需要传的数据
     * @category object
     */
    params:PropTypes.object,
    /**
     * @text 导航栏内容
     * @category array
     */
    navigationBarDate:PropTypes.array,
    /**
     * @text tab栏切换方法
     * @category array
     */
    tabChange:PropTypes.func,
};

MyTable.defaultProps={
    placeholder:'全部稿件',
    searchPlaceholder:'请输入关键字',
};
export default MyTable;